<div
  class="user-container"
  matTooltip="{{ tooltip || fullName }}"
  matTooltipShowDelay="400"
  matTooltipHideDelay="400"
  *ngIf="fullName[0] !== '+' && tooltip !== 'no'; else noTooltip">
  <button mat-mini-fab class="user-btn" [ngClass]="{locked: locked}">
    <img *ngIf="avatarUrl; else elseBlock" src="{{ avatarUrl }}" alt="" />
    <ng-template #elseBlock>
      <span class="user-initials">{{ initials }}</span>
    </ng-template>
  </button>
</div>

<ng-template #noTooltip>
  <div class="user-container">
    <button mat-mini-fab class="user-btn" [ngClass]="{locked: locked}">
      <img *ngIf="avatarUrl; else elseBlock" src="{{ avatarUrl }}" alt="" />
      <ng-template #elseBlock>
        <span class="user-initials">{{ initials }}</span>
      </ng-template>
    </button>
  </div>
</ng-template>
